var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 88,
    viewBox: "0 0 114 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.036 75.9775C111.036 82.7576 105.735 87.2382 99.2362 87.2382H40.2357C33.7365 87.2382 28.4356 82.7576 28.4356 75.9775H111.036ZM96.2861 19.043H43.1858C41.5725 19.043 40.2357 20.4376 40.2357 22.1206V57.5118C40.2357 63.4262 44.8909 67.9935 50.5607 67.9935H83.011C88.8186 67.9935 93.8263 63.2555 93.336 55.9731C119.981 57.5751 120.744 20.3242 96.2861 19.043ZM93.336 46.7404V28.2755C107.97 25.8263 110.227 48.2576 93.336 46.7404ZM46.2116 13.4726H55.0797L48.4612 2.64626V-33.7445H55.6929C61.1025 -33.7445 61.1025 -41.7285 55.6929 -41.7285H3.01702C-2.39229 -41.7285 -2.39229 -33.7445 3.01702 -33.7445H10.2488V2.64626L-26.4011 66.051C-29.8421 72.1601 -27.6822 75.9778 -20.3744 75.9778H22.8829V67.9932H-18.5942L18.0036 4.68602V-33.7445H40.7053V4.68631L46.2116 13.4726ZM32.7291 59.9777H-4.51147L19.0139 19.043H32.7289L32.7291 59.9777Z",
    fill: "#9277FF",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.d9dcfc3139462cf234b3d1b464d229c4.svg";
export { ForwardRef as ReactComponent };